import { getCookie } from "../../helper";
import { Login, Signup } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { setUserFromShopify, selectLogInUsername, setLogInUser, graphStatus,fetchUserAccountInfo } from "./authSlice"
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { checkAgentEnabled } from "../../layout/AIAgent/agentSlice";

export default function AuthenticateDashboard(component) {

    return function AuthenticateDashboard(props) {
        const dispatch = useDispatch();
        const location = useLocation();
        const sessionUser = useSelector(selectLogInUsername);
        const user = sessionUser?.split('@')[0]
        const referer = document.referrer ? document.referrer : '';
        // console.log("reffer", referer)

        useEffect(() => {
            if (!user) return;
            dispatch(graphStatus(user))
            dispatch(fetchUserAccountInfo(user))
            dispatch(checkAgentEnabled(user))
        }, [user])
        
        if (referer.includes('shopify')) {
            if (sessionUser) return component(props);
            else {
                dispatch(setUserFromShopify(referer))
                if(location.pathname.includes('start-free-trial')) return <Signup/>
                return <Login />;
            }
        } else if (!sessionUser) {
            const user = getCookie('user');
            if (user) {
                // TODO: debug why this code is running on login action
                console.log("----user from cookies----", user);
                dispatch(setLogInUser(user))
                return component(props);
            }
            if(location.pathname.includes('start-free-trial')) return <Signup/>
            return <Login />;
        } else if(sessionUser) return component(props);
    }
}